import { ConfigService } from "./../config-service/config.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Messages } from "@stockcare-models/Messages";


@Injectable({
  providedIn: "root",
})
export class MessagesService {
  messages: Messages[] = [];

  constructor(
    private http: HttpClient,
    private configurationService: ConfigService
  ) {
  }

  getMessages() {
    return this.http.get<Messages[]>(
      `${this.configurationService.config.baseUrl}/Messages/GetUserMessages`
    );
  }


  readMessage(messageId: number) {

    var parameters = {
      id: +messageId
    };

    return this.http.post<any>(
      `${this.configurationService.config.baseUrl}/Messages/MarkMessageAsRead`, parameters 
    );
  
  }

  messagesAvailable() {
    return this.http.get<number>(
      `${this.configurationService.config.baseUrl}/Messages/GetNewMessageCount`
    );
  }


}